import React, { useState, useLayoutEffect, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';

const logoSrc = `${process.env.PUBLIC_URL || ''}/logo-white.png`;

export const HeaderAlt = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [allowHeaderTransition, setAllowHeaderTransition] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';
  const useSolidHeader = !isHomePage || isScrolled;

  useLayoutEffect(() => {
    setIsMenuOpen(false);
    setIsScrolled(false);
    setAllowHeaderTransition(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isHomePage) return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      setAllowHeaderTransition(true);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  const navLinks = [
    { path: '/', label: 'Início' },
    { path: '/sobre', label: 'Sobre' },
    { path: '/catalogos', label: 'Catálogos' },
    { path: '/contactos', label: 'Contactos' }
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 ${
          useSolidHeader
            ? 'py-4 bg-[#262d37]'
            : 'bg-transparent mix-blend-difference py-6 sm:py-8'
        } ${
          isHomePage && allowHeaderTransition
            ? 'transition-[padding,background-color] duration-300'
            : 'transition-none'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center h-8 sm:h-10">
              <img
                src={logoSrc}
                alt="LuxDall"
                className="h-full w-auto object-contain"
              />
            </Link>

            <button
              onClick={() => setIsMenuOpen(true)}
              className="relative w-12 h-12 flex flex-col justify-center items-end gap-2 group"
            >
              <span className="w-10 h-0.5 bg-white transition-all group-hover:w-8" />
              <span className="w-8 h-0.5 bg-white transition-all group-hover:w-10" />
              <span className="w-6 h-0.5 bg-white transition-all group-hover:w-10" />
            </button>
          </div>
        </div>
      </header>

      {isMenuOpen && (
        <div className="fixed inset-0 z-[100] bg-[#262d37]/95 backdrop-blur-xl flex flex-col">
          <div className="flex-shrink-0 py-4">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
              <div className="flex justify-between items-center">
                <Link
                  to="/"
                  onClick={() => setIsMenuOpen(false)}
                  className="flex items-center h-8 sm:h-10"
                >
                  <img
                    src={logoSrc}
                    alt="LuxDall"
                    className="h-full w-auto object-contain"
                  />
                </Link>

                <button
                  onClick={() => setIsMenuOpen(false)}
                  className="w-12 h-12 flex items-center justify-center text-white hover:rotate-90 transition-transform duration-300"
                >
                  <X size={28} />
                </button>
              </div>
            </div>
          </div>

          <nav className="flex-1 flex flex-col justify-center items-center gap-8">
            {navLinks.map((link, index) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`text-4xl md:text-5xl uppercase font-bold transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-white'
                    : 'text-white hover:text-white/20'
                }`}
                style={{ animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both` }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex-shrink-0 p-8 text-center text-neutral-400">
            <p>Fale Connosco</p>
            <a href="mailto:geral@luxdall.pt" className="text-sm text-white">geral@luxdall.pt</a>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};
